// Framework-agnostic reader for OneTrust consent + US privacy signals.
// window.OnetrustActiveGroups is a comma-wrapped list, e.g. ",C0001,C0004,".
// GPP (__gpp) is an ASYNC callback API — never read it inline; cache the latest
// value and read the cache synchronously.
import { CATEGORIES } from './otCategories';

const wrap = () => ',' + (window.OnetrustActiveGroups || '') + ',';

export const activeGroups = () => (window.OnetrustActiveGroups || '').split(',').filter(Boolean);
export const hasConsent = (id) => wrap().indexOf(',' + id + ',') !== -1;
export const gpcOptOut = () => navigator.globalPrivacyControl === true;

// Opted out of targeted advertising ("sale/share"): Targeting (C0004) not granted,
// or a Global Privacy Control signal. This single opt-out state is what every
// consent ad-macro below is derived from. Reliable across tenants — unlike
// decoding a specific GPP section (usnat vs usca), whose fields vary by config.
export const isOptedOut = () => !hasConsent(CATEGORIES.TARGETING) || gpcOptOut();
export const hasTargetingConsent = () => !isOptedOut();
export const isSaleShareOptedOut = () => isOptedOut(); // back-compat alias

let _gpp = { string: '', sid: '' };
export const gppString = () => _gpp.string;
export const gppSid = () => _gpp.sid; // GPP section ids, underscore-joined (e.g. "6_7")

let _gppRegistered = false;
export const initPrivacySignals = () => {
  if (_gppRegistered) {return;}
  const store = (pd) => {
    if (!pd) {return;}
    _gpp.string = pd.gppString || '';
    const sections = pd.applicableSections;
    _gpp.sid = Array.isArray(sections) ? sections.filter((s) => s && s !== -1).join('_') : '';
  };
  const register = () => {
    if (typeof window.__gpp !== 'function') {return false;}
    _gppRegistered = true;
    // The listener fires on registration ("listenerRegistered") with the current
    // pingData, and again on every consent change.
    window.__gpp('addEventListener', (data) => data && store(data.pingData));
    return true;
  };
  if (register()) {return;}
  // OneTrust's __gpp loads asynchronously and often isn't defined yet when this
  // first runs (React effect vs. the OT SDK boot). Retry until it exists — otherwise
  // gpp/gpp_sid never get cached and are dropped from the ad request.
  let tries = 0;
  const timer = setInterval(() => {
    if (register() || (tries += 1) > 40) {clearInterval(timer);}
  }, 500);
};
